import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';

@Injectable()
export class RxEmitter {
  private _subjects;

  constructor() {
    this._subjects = {};
  }

  private _createNamespace(namespace) {
    return '$' + namespace;
  }

  private _createRxSubject(namespace): Subject<any> {
    const ns = this._createNamespace(namespace);

    if (!this._subjects[ns]) {
      this._subjects[ns] = new Subject();
    }

    return this._subjects[ns];
  }

  send(namespace: string, data?: any) {
    const subject = this._createRxSubject(namespace);

    subject.next(data);
  }

  subscribe(namespace, handler): Subscription {
    const subject = this._createRxSubject(namespace);

    return subject.subscribe(handler);
  }

  getNamespaceObservable(namespace: string): Observable<any> {
    return this._createRxSubject(namespace).asObservable();
  }
}

// TODO: until we only have Angular 2 components that use the RxEmitter we need to make sure that
// both Angular 1 and Angular 2 uses the SAME RxEmitter instance
export const RxEmitterInstance = new RxEmitter();
